module.exports = __webpack_public_path__ + "static/photo9-07b73130cdd5f75f258878660061f1f7.png";